import React, { useContext, useState } from "react";

import { Link } from "react-router-dom";

import { SettingsContext } from "../../contexts";
import { DataHelper } from "../../helpers";
import { Separator } from "../../components";
import { Money } from "../index.jsx";
import { getFileUrl } from "../../core/config/api.js";
import { orderItemCurrency } from "../../core/currency";

// TODO WTF is this?
const HorizontalListing = ({ cart, item, readonly }) => {
  const settings = useContext(SettingsContext);
  const [quantity, setQuantity] = useState(item.quantity);

  const listing = item.listing;
  const product = listing.product;

  const isReward = DataHelper.REWARD_CATEGORY_ID === product.category_id;
  const reward = isReward
    ? window.REWARDS.find((r) => r.listing_id === listing.id)
    : null;

  const onRemoveClick = (e) => {
    e.preventDefault();
    cart.removeItem(item.id || item.listing_id);
  };

  // Quantity is always 1 for a watch, so the input is display-only and this
  // handler deliberately does nothing. Its former body — parse, validate,
  // write item.quantity, cart.update() — sat below an unconditional `return`
  // and has been unreachable ever since; git has it if quantities ever become
  // real. The handler stays so the input remains a controlled component.
  const onQuantityChange = () => {};

  const onQuantityBlur = () => {
    setQuantity(item.quantity);
  };

  return (
    <li>
      <div className="d-flex justify-content-between">
        <div>
          <img src={getFileUrl(product.images[0].id)} />
        </div>
        <div className="details flex-grow-1 d-flex flex-column justify-content-between">
          <div className="d-flex" style={{ marginBottom: "16px" }}>
            <div className="flex-grow-1">
              {isReward && <h5>Reward: {reward.title}</h5>}

              {!isReward && (
                <Link
                  to={
                    "/product/" + listing.id + `?${settings.iframeQueryParams}`
                  }
                >
                  <h5>
                    {product.brand.name} {product.model.name}
                  </h5>
                </Link>
              )}

              <p>{product.reference_number}</p>
            </div>

            {!isReward && (
              // `item.price` is the ORDER ITEM's amount, so it is labelled from
              // the record that describes that amount — see orderItemCurrency.
              // It used to read `listing.currency` with a store-base fallback,
              // which is right only while the item still mirrors the listing, and
              // stamps the base symbol onto a foreign amount when it does not.
              <Money
                currency={orderItemCurrency(item, listing)}
                amount={item.quantity * item.price}
                className="align-self-start price"
              />
            )}

            {isReward && (
              <span className="align-self-start price">{reward.cost}P</span>
            )}
          </div>

          <div className="d-flex justify-content-between">
            <div className="align-self-center">
              {!readonly && !isReward && (
                <input
                  type="text"
                  maxLength={3}
                  className="quantity"
                  onChange={onQuantityChange}
                  onBlur={onQuantityBlur}
                  value={quantity}
                  readOnly={true /** Quantity must always be 1 */}
                />
              )}

              <span className="align-self-center">
                {item.quantity > 1 && readonly && item.quantity}
              </span>
            </div>

            {!readonly && (
              <a
                href="#"
                onClick={onRemoveClick}
                className="align-self-center remove"
              >
                Remove product
              </a>
            )}
          </div>
        </div>
      </div>

      <Separator noMargin />
    </li>
  );
};

export default HorizontalListing;
